export default __webpack_public_path__ + "static/media/blog1.7343a3ec.jpg";